import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";

export const impressionNoFeeWeekendPopup = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    params: { cartId: string; originalCartId: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_NO_WEEKEND_FEE_POPUP,
        context: JSON.stringify({ cartId: params.cartId, originalCartId: params.originalCartId }),
    });
};

export const clickNoFeeWeekendPopup = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    params: { cartId: string; originalCartId: string; clickAction: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_NO_WEEKEND_FEE_POPUP,
        label: params.clickAction,
        context: JSON.stringify({ cartId: params.cartId, originalCartId: params.originalCartId }),
    });
};
